document.addEventListener('DOMContentLoaded', () => {
	const menus = document.querySelectorAll('.wp-block-mega-menu-menu');

	menus.forEach((menu) => {
		const breakpoint = parseInt(menu.dataset.breakpoint || 1024);
		const toggle = menu.querySelector('.menu-toggle');

		function checkMode() {
			if (window.innerWidth <= breakpoint) {
				menu.classList.add('is-mobile');
			} else {
				menu.classList.remove('is-mobile');
				menu.classList.remove('is-open');

				document.body.classList.remove('menu-open'); // <-- IMPORTANT

				menu.querySelectorAll('.mega-menu-column').forEach((col) => {
					col.classList.remove('is-open');
				});
			}
		}

		checkMode();
		window.addEventListener('resize', checkMode);

		/* BURGER */
		toggle.addEventListener('click', () => {
			menu.classList.toggle('is-open');

			const expanded = menu.classList.contains('is-open');
			toggle.setAttribute('aria-expanded', expanded);

			// SCROLL LOCK
			if (expanded) {
				document.body.classList.add('menu-open');
			} else {
				document.body.classList.remove('menu-open');
			}
		});

		/* ACCORDION (NEW) */
		const columnToggles = menu.querySelectorAll('.mega-menu-toggle');

		columnToggles.forEach((btn) => {
			btn.addEventListener('click', () => {
				// only act in mobile
				if (!menu.classList.contains('is-mobile')) return;

				const column = btn.closest('.mega-menu-column');
				const isOpen = column.classList.contains('is-open');

				// CLOSE ALL
				menu.querySelectorAll('.mega-menu-column').forEach((col) => {
					const content = col.querySelector('.mega-menu-links');
					content.style.maxHeight = 0;

					col.classList.remove('is-open');
					const b = col.querySelector('.mega-menu-toggle');
					if (b) b.setAttribute('aria-expanded', 'false');
				});
				const content = column.querySelector('.mega-menu-links');

				// OPEN CURRENT (if it was closed)
				if (!isOpen) {
					content.style.maxHeight = content.scrollHeight + 'px';
					column.classList.add('is-open');
					btn.setAttribute('aria-expanded', 'true');
				} else {
					content.style.maxHeight = 0;
				}
			});
		});

		/* CLOSE MENU ON SAME-PAGE NAVIGATION */
		const links = menu.querySelectorAll('a');
		links.forEach((link) => {
			link.addEventListener('click', (e) => {
				const href = link.getAttribute('href');

				if (!href) return;

				const url = new URL(href, window.location.origin);

				const isSamePage =
					url.pathname === window.location.pathname &&
					url.origin === window.location.origin;

				const isAnchorLink = url.hash.length > 0;

				if (isSamePage && isAnchorLink) {
					menu.classList.remove('is-open');
					toggle.setAttribute('aria-expanded', 'false');
					document.body.classList.remove('menu-open');
				}
			});
		});
	});
});
